module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-BOOSTER-GREEN-5.6c076534.jpg";